<template>
  <div>
    <div style="display: inline-block" class="q-mr-sm">
      {{ getTrapInfo(JSON.parse(data.props.row.extendedData)) }}
    </div>
  </div>
</template>

<script>
  export default {
    props: ["data"],
    data: () => ({}),
    methods: {
      getTrapInfo(data) {
        let res = data.find((e) => e.traps);
        return res ? res.traps : "";
      },
    },
  };
</script>
